import { OrderItemProductJson } from 'src/models/order/interfaces/OrderItemJson'
import DurationPeriod from 'src/models/period/DurationPeriod'
import { DateTime } from 'luxon'
import { frameworkQuasarConfig } from 'src/config/quasarConfig'
import { OrderItemStatus } from 'src/models/order/enums/OrderItemStatus'
import LockerType from 'src/models/locker/LockerType'
import Rental from 'src/models/rental/Rental'

export default abstract class Product {
  readonly productType: string

  constructor(productType: string) {
    this.productType = productType
  }
  abstract readonly lockerType: LockerType
  abstract readonly durationPeriod: DurationPeriod
  readonly rental?: Rental | null

  abstract toJson(): OrderItemProductJson
  abstract getStatus(timezone?: string): OrderItemStatus | undefined

  getUnitName(): string | undefined {
    return this.rental?.unit.displayName
  }

  getLockerName(): string | number | undefined {
    return this.rental?.locker.displayName()
  }

  getLockerType(): LockerType | undefined {
    return this.lockerType
  }

  getDurationPeriods() {
    const { startDate, endDate } = this.durationPeriod
    if (DateTime.isDateTime(startDate) && DateTime.isDateTime(endDate)) {
      return {
        startDate: startDate.toFormat(frameworkQuasarConfig.datetimeFormat),
        endDate: endDate.toFormat(frameworkQuasarConfig.datetimeFormat),
      }
    }
  }
}
